import { useEffect, useRef, useState } from "react";
import { Camera, X, Loader2 } from "lucide-react";

// Full-screen live camera (no gallery). Returns a JPEG File via onShot.
export const LiveCamera = ({ open, onClose, onShot, title }) => {
  const video = useRef(null);
  const stream = useRef(null);
  const [err, setErr] = useState("");
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    setErr(""); setReady(false);
    navigator.mediaDevices?.getUserMedia({ video: { facingMode: { ideal: "environment" }, width: { ideal: 1920 }, height: { ideal: 1080 } }, audio: false })
      .then((s) => { stream.current = s; if (video.current) { video.current.srcObject = s; video.current.play().catch(() => {}); } })
      .catch(() => setErr("ما قدرنا نفتح الكاميرا. اسمح للمتصفح باستخدام الكاميرا وأعد المحاولة."));
    if (!navigator.mediaDevices?.getUserMedia) setErr("المتصفح ما يدعم الكاميرا المباشرة. افتح الرابط في Chrome أو Safari.");
    return () => { stream.current?.getTracks().forEach((t) => t.stop()); stream.current = null; };
  }, [open]);

  const shoot = () => {
    const v = video.current;
    if (!v?.videoWidth) return;
    const c = document.createElement("canvas");
    c.width = v.videoWidth; c.height = v.videoHeight;
    c.getContext("2d").drawImage(v, 0, 0);
    c.toBlob((b) => { if (b) { onShot(new File([b], `live_${Date.now()}.jpg`, { type: "image/jpeg" })); onClose(); } }, "image/jpeg", 0.9);
  };

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] flex flex-col bg-black" dir="rtl" data-testid="live-camera">
      <div className="flex items-center justify-between px-4 py-3 text-white">
        <span className="font-bold">{title}</span>
        <button onClick={onClose} className="rounded-full bg-white/15 p-2" data-testid="live-camera-close"><X className="h-5 w-5" /></button>
      </div>
      <div className="relative flex-1 overflow-hidden">
        <video ref={video} playsInline muted autoPlay onLoadedData={() => setReady(true)} className="h-full w-full object-cover" />
        {!ready && !err && <Loader2 className="absolute inset-0 m-auto h-8 w-8 animate-spin text-white" />}
        {err && <div className="absolute inset-0 flex items-center justify-center p-8 text-center text-sm text-white" data-testid="live-camera-error">{err}</div>}
      </div>
      <div className="flex justify-center py-6">
        <button onClick={shoot} disabled={!ready} className="flex h-20 w-20 items-center justify-center rounded-full border-4 border-white bg-white/20 disabled:opacity-40" data-testid="live-camera-shoot">
          <Camera className="h-8 w-8 text-white" />
        </button>
      </div>
    </div>
  );
};
